export enum PathRoute {
  HOME = '/',
}
